import { predicate } from "@prismicio/client"
import type { PrismicDocument } from "@prismicio/types"

import type {
  Article,
  Author,
  BasePrismicDocument,
  Category,
  ColorScheme,
  Podcast,
  PodcastEpisode,
  PrismicSearchResponse,
} from "~/api/prismic/types"

import { DocumentType } from "./enums"

export type PrismicResponsePromise<T> = Promise<T | undefined>

export type PrismicSearchPromise<T extends BasePrismicDocument> =
  PrismicResponsePromise<PrismicSearchResponse<T>>

function getDocField<D extends PrismicDocument>(
  documentType: D["type"],
  isPredicate?: boolean,
) {
  return (field: keyof D["data"]) => {
    const parts = [documentType, field]

    if (isPredicate) parts.unshift("my")

    return parts.join(".")
  }
}

const { ARTICLE, AUTHOR, CATEGORY, COLOR_SCHEME, PODCAST, PODCAST_EPISODE } =
  DocumentType

export const getField = {
  article: getDocField<Article>(ARTICLE),
  author: getDocField<Author>(AUTHOR),
  category: getDocField<Category>(CATEGORY),
  colorScheme: getDocField<ColorScheme>(COLOR_SCHEME),
  podcast: getDocField<Podcast>(PODCAST),
  podcastEpisode: getDocField<PodcastEpisode>(PODCAST_EPISODE),
}

export const my = {
  article: getDocField<Article>(ARTICLE, true),
  author: getDocField<Author>(AUTHOR, true),
  category: getDocField<Category>(CATEGORY, true),
  colorScheme: getDocField<ColorScheme>(COLOR_SCHEME, true),
  podcast: getDocField<Podcast>(PODCAST, true),
  podcastEpisode: getDocField<PodcastEpisode>(PODCAST_EPISODE, true),
}

export const Predicates = predicate
